/**
 * Router basename for React Router.
 *
 * Assets use homepage "." in package.json (relative URLs) so the same build works at
 * domain root (Emergent preview) and at https://alearninglab.com/in/.
 *
 * Optional build override: REACT_APP_ROUTER_BASENAME=/ or /in
 */

function normalizeEnvBasename(value) {
  if (value === undefined || value === null) return null;
  const trimmed = String(value).trim();
  if (trimmed === "" || trimmed === "/" || trimmed === ".") return "";
  return trimmed.startsWith("/") ? trimmed.replace(/\/+$/, "") || "" : `/${trimmed.replace(/\/+$/, "")}`;
}

/** Call when rendering (needs window on the client). */
export function getRouterBasename() {
  const fromEnv = normalizeEnvBasename(process.env.REACT_APP_ROUTER_BASENAME);
  if (fromEnv !== null) return fromEnv;

  if (typeof window !== "undefined") {
    const { pathname } = window.location;
    if (pathname === "/in" || pathname.startsWith("/in/")) return "/in";
  }

  // Emergent / other previews that serve build/ at /
  return "";
}
